module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"gift_card":"Geschenkkarte"},"en":{"gift_card":"Gift Card"},"es":{"gift_card":"Tarjeta Regalo"},"fr":{"gift_card":"Carte Cadeau"},"ja":{"gift_card":"ギフトカード"},"pt":{"gift_card":"Vale Presente"}}')
  delete Component.options._Ctor
}
